import type { FollowerTemplate } from '../../schemas/follower';
import { barbaroBandaDiGuerraTemplate } from './barbaro-banda-di-guerra';
import { druidoSupportoElementaleTemplate } from './druido-supporto-elementale';
import { magoFamiglioTemplate } from './mago-famiglio';
import { rangerCompagnoAnimaleTemplate } from './ranger-compagno-animale';
import { sciamanoAnimareZombiTemplate } from './sciamano-animare-zombi';
import { warlockBraccioDestroTemplate } from './warlock-braccio-destro';
import { warlockUnGiustoSovranoTemplate } from './warlock-un-giusto-sovrano';

/**
 * Catalogo dei `FollowerTemplate`.
 *
 * Cresciuto in modo incrementale:
 *  - **FI-8a** (pilota, 2026-05-11): `ranger-compagno-animale`.
 *  - **FI-8b** (D1.5, 2026-05-12): `mago-famiglio` — esercita per la prima
 *    volta `FollowerTemplate.peculiaritiesFromChoiceGroup` (discriminated
 *    union su 5 kind di effect eterogenei) e `MoveChoice.allowDuplicate`.
 *  - **FI-8c/d** (D8a, 2026-05-15): `druido-supporto-elementale` +
 *    `sciamano-animare-zombi` — esercitano `recruitRoll` (pickCount dinamico
 *    via esito del tiro), `archetypeTagBundle` (tag intrinseci da archetype),
 *    e i 2 nuovi kind D8a di peculiarità (`hp-bonus-scaling`, `cost-suspension`).
 *  - **FI-8e/f** (D8b, 2026-05-15): `warlock-braccio-destro` +
 *    `warlock-un-giusto-sovrano` (2° emissario, template gemello, Q3=β) +
 *    `barbaro-banda-di-guerra` — esercitano `FollowerTemplate.upgrades`
 *    (Khan dei Khan modifica la Banda), `primarySkillFromNarrativeField` +
 *    `traitFromNarrativeFields` (Braccio Destro: Abilità primaria + capacità
 *    custom sempre presenti via narrativeField), `type: 'hireling'` +
 *    `type: 'collective'` (prima istanza), `load: 'narrative'` (prima
 *    istanza). Catalogo cresciuto da 4 a 7 entry.
 *
 * Cavalcatura Paladino: fuori scope sistema (FI-39, decisione D8a Q6).
 * Chain Servitore Competente/Maestria/Sosia/Animale Speciale: FI-41 (P3,
 * pattern "upgrade with choice" da affrontare quando avremo 3 casi).
 */
export const FOLLOWER_TEMPLATES: Record<string, FollowerTemplate> = {
  'barbaro-banda-di-guerra': barbaroBandaDiGuerraTemplate,
  'druido-supporto-elementale': druidoSupportoElementaleTemplate,
  'mago-famiglio': magoFamiglioTemplate,
  'ranger-compagno-animale': rangerCompagnoAnimaleTemplate,
  'sciamano-animare-zombi': sciamanoAnimareZombiTemplate,
  'warlock-braccio-destro': warlockBraccioDestroTemplate,
  'warlock-un-giusto-sovrano': warlockUnGiustoSovranoTemplate,
};

/** ID dei template noti (utile per autocompletion). */
export type KnownFollowerTemplateId = keyof typeof FOLLOWER_TEMPLATES;

/**
 * Lookup di un `FollowerTemplate` per id. Ritorna `undefined` se non noto.
 *
 * Le PR successive estendono il record; il catalogo cresce in modo additivo.
 */
export function getFollowerTemplate(id: string): FollowerTemplate | undefined {
  return FOLLOWER_TEMPLATES[id];
}

export {
  barbaroBandaDiGuerraTemplate,
  druidoSupportoElementaleTemplate,
  magoFamiglioTemplate,
  rangerCompagnoAnimaleTemplate,
  sciamanoAnimareZombiTemplate,
  warlockBraccioDestroTemplate,
  warlockUnGiustoSovranoTemplate,
};
export * from './traits';
